import React from "react";
import { PageHeader } from "./PageHeader";

import logoKrakow from "../img/sponsors/logo-krakow.png";
import logoPactt from "../img/sponsors/logo-pactt.png";
import logoCittru from "../img/sponsors/logo-cittru.png";
import logoCttagh from "../img/sponsors/logo-cttagh.png";
import logoPan from "../img/sponsors/logo-pan.png";
import logoMnisw from "../img/sponsors/logo-mnisw.png";
import logo3b from "../img/sponsors/logo-3bScientific.png";
import logoEduka from "../img/sponsors/logo-eduka.png";
import logoLd from "../img/sponsors/logo-ldDidactic.png";
import logoMarr from "../img/sponsors/logo-marr.png";
import logoMeasline from "../img/sponsors/logo-mesline.png";
import logoOpenStax from "../img/sponsors/logo-openstax.png";
import logoPolatom from "../img/sponsors/logo-polatom.png";
import logoP42 from "../img/sponsors/logo-project42.png";
export const SponsorsList  = props => {
    return (
        <React.Fragment>
            <PageHeader title="Patroni, partnerzy, sponsorzy" />
            <div class="content-wrapper">
                <div class="main-content sponsors">
                    <div className="container text-center">
                        <h2>Patroni</h2>
                        <div className="row organisers-wall">
                            <div className="col-xs-6 col-sm-3 col-md-3">
                                <a href="https://www.gov.pl/web/nauka" target="_blank" rel="noopener noreferrer">
                                    <figure>
                                        <img src={logoMnisw} className="img-responsive mypic" alt="Ministerstwo Nauki i Szkolnictwa Wyższego"/>
                                        <figcaption>Minister Nauki i Szkolnictwa Wyższego</figcaption>
                                    </figure>
                                </a>
                            </div>
                            <div className="col-xs-6 col-sm-3 col-md-3">
                                <a href="http://www.krakow.pl" target="_blank" rel="noopener noreferrer">
                                    <figure>
                                        <img src={logoKrakow} className="img-responsive mypic" alt="Miasto Kraków, Prezydent Miasta Krakowa"/>
                                        <figcaption>Miasto Kraków<br/> Prezydent Miasta Krakowa</figcaption>
                                    </figure>
                                </a>
                            </div>
                            <div className="col-xs-6 col-sm-3 col-md-3">
                            </div>
                            <div className="col-xs-6 col-sm-3 col-md-3">
                            </div>
                        </div>
                        <h2>Partnerzy i sponsorzy</h2>


                        <div className="row organisers-wall">
                            <div className="col-xs-6 col-sm-3 col-md-3">
                                <a href="http://www.ctt.agh.edu.pl/" target="_blank" rel="noopener noreferrer">
                                    <figure>
                                        <img src={logoCttagh} className="img-responsive mypic" alt="Centrum Transferu Technologii CTT, AGH "/>
                                        <figcaption>Centrum Transferu Technologii<br/>Akademii Górniczo-Hutniczej</figcaption>
                                    </figure>
                                </a>
                            </div>
                            <div className="col-xs-6 col-sm-3 col-md-3">
                                <a href="http://www.cittru.uj.edu.pl" target="_blank" rel="noopener noreferrer">
                                    <figure>
                                        <img src={logoCittru} className="img-responsive mypic" alt="Centrum Transferu Technologii CITTRU, UJ"/>
                                        <figcaption>Centrum Transferu Technologii<br/>Uniwersytetu Jagiellońskiego </figcaption>
                                    </figure>
                                </a>
                            </div>
                            <div className="col-xs-6 col-sm-3 col-md-3">
                                <a href="https://www.gov.pl/web/nauka" target="_blank" rel="noopener noreferrer">
                                    <figure>
                                        <img src={logoMnisw} className="img-responsive mypic" alt="Ministerstwo Nauki i Szkolnictwa Wyższego"/>
                                        <figcaption>933/P-DUN/2019 - Działaność Upowszechniająca Naukę MNISW</figcaption>
                                    </figure>
                                </a>
                            </div>
                            <div className="col-xs-6 col-sm-3 col-md-3">
                               <a href="http://www.pan.pl" target="_blank" rel="noopener noreferrer">
                                    <figure>
                                        <img src={logoPan} className="img-responsive mypic" alt="Polska Akademia Nauk"/>
                                        <figcaption>Polska Akademia Nauk</figcaption>
                                    </figure>
                               </a>
                            </div>
                        </div>




                        <div className="row organisers-wall">
                            <div className="col-xs-6 col-sm-3 col-md-3">
                                <a href="http://www.pactt.pl" target="_blank" rel="noopener noreferrer">
                                    <figure>
                                        <img src={logoPactt} className="img-responsive mypic" alt="Porozumienie Akademickich Centrów Transferu Technologii"/>
                                        <figcaption>Porozumienie Akademickich <br/>Centrów Transferu Technologii</figcaption>
                                    </figure>
                                </a>
                            </div>
                            <div className="col-xs-6 col-sm-3 col-md-3">
                                <a href="https://www.3bscientific.com/" target="_blank" rel="noopener noreferrer">
                                    <figure>
                                        <img src={logo3b} className="img-responsive mypic" alt="3B Scientific"/>
                                        <figcaption>3B Scientific</figcaption>
                                    </figure>
                                </a>
                            </div>
                            <div className="col-xs-6 col-sm-3 col-md-3">
                                <a href="https://www.eduka.com.pl/" target="_blank" rel="noopener noreferrer">
                                    <figure>
                                        <img src={logoEduka} className="img-responsive mypic" alt="Eduka"/>
                                        <figcaption>Eduka</figcaption>
                                    </figure>
                                </a>
                            </div>
                            <div className="col-xs-6 col-sm-3 col-md-3">
                                <a href="https://www.ld-didactic.de/" target="_blank" rel="noopener noreferrer">
                                    <figure>
                                        <img src={logoLd} className="img-responsive mypic" alt="LD DIDACTIC GROUP"/>
                                        <figcaption>LD DIDACTIC GROUP</figcaption>
                                    </figure>
                                </a>
                            </div>
                            <div className="col-xs-6 col-sm-3 col-md-3">
                                <a href="https://www.marr.pl/" target="_blank" rel="noopener noreferrer">
                                    <figure>
                                        <img src={logoMarr} className="img-responsive mypic" alt="MARR: Małopolska Agencja Rozwoju Regionalnego"/>
                                        <figcaption>MARR: Małopolska Agencja Rozwoju Regionalnego</figcaption>
                                    </figure>
                                </a>
                            </div>
                            <div className="col-xs-6 col-sm-3 col-md-3">
                                <a href="http://measline.com/" target="_blank" rel="noopener noreferrer">
                                    <figure>
                                        <img src={logoMeasline} className="img-responsive mypic" alt="MeasLine"/>
                                        <figcaption>MeasLine</figcaption>
                                    </figure>
                                </a>
                            </div>
                            <div className="col-xs-6 col-sm-3 col-md-3">
                                <a href="https://openstax.org/" target="_blank" rel="noopener noreferrer">
                                    <figure>
                                        <img src={logoOpenStax} className="img-responsive mypic" alt="OpenStax"/>
                                        <figcaption>OpenStax</figcaption>
                                    </figure>
                                </a>
                            </div>
                            <div className="col-xs-6 col-sm-3 col-md-3">
                                <a href="https://www.polatom.pl/" target="_blank" rel="noopener noreferrer">
                                    <figure>
                                        <img src={logoPolatom} className="img-responsive mypic" alt="Narodowe Centrum Badań Jądrowych, Ośrodek Radioizotopów POLATOM"/>
                                        <figcaption>Narodowe Centrum Badań Jądrowych, Ośrodek Radioizotopów POLATOM</figcaption>
                                    </figure>
                                </a>
                            </div>
                            <div className="col-xs-6 col-sm-3 col-md-3">
                                <a href="https://project42.pl/" target="_blank" rel="noopener noreferrer">
                                    <figure>
                                        <img src={logoP42} className="img-responsive mypic" alt="Project42"/>
                                        <figcaption>Project42</figcaption>
                                    </figure>
                                </a>
                            </div>



                        </div>


                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};
SponsorsList.propTypes = {};
